import { createContext } from 'react';
import { AccountsOrdersPendingParam } from '../type';

export const accountsOrdersPendingParamsContext = createContext<Partial<AccountsOrdersPendingParam>>({});
